<template lang="pug">
  transition(name='modal')
    .modal-mask(@mousedown='closeModal')
      .modal-wrapper
        .modal-container(@mousedown.stop :style='style' :class='{empty}')
          .modal-header.row.middle(v-if='!empty')
            .width-100.m-right-4
              h3.title-medium.red(v-if='errorTitle') {{ errorTitle }}
              h3.title-medium(v-else) {{ title }}
            button.close-button.self-start.m-left-auto(type='button' @click='closeModal' v-if='closeButton')
              img(:src='closeIcon' alt='close')
          .modal-content
            slot
</template>

<script>
import closeIcon from '../assets/ic_cross.svg'

export default {
  props: {
    title: { type: String },
    closeButton: { type: Boolean, default: true },
    empty: { type: Boolean },
    errorTitle: { type: String },
    maxWidth: { type: String },
    overrideStyle: { type: Object }
  },
  data() {
    return { closeIcon }
  },
  computed: {
    style() {
      return { '--max-width': this.maxWidth, ...this.overrideStyle }
    }
  },
  methods: {
    closeModal(event) {
      this.$emit('closeModal')
    }
  }
}
</script>

<style lang="scss" scoped>
@import '../scss/variables/colors';
@import '../scss/variables/sizes';

.modal-mask {
  backdrop-filter: blur(1px);
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100vh;
  background-color: $black-translusent;
  display: table;
  transition: opacity .3s ease;
  z-index: 99;
}

.modal-wrapper {
  display: table-cell;
  vertical-align: middle;
}

.modal-container {
  background-color: $white;
  border-radius: 10px;
  box-shadow: 0 2px 8px 0 $shadow-gray;
  transition: all .3s ease;
  margin: auto;
  max-width: var(--max-width, 495px);
  padding: 35px;
  width: 100%;
  &.empty{
    padding: 0;
  }
}

.close-button {
  height: 18px;
  width: 18px;
}
</style>
